<template>
  <div class="area-tree">
    <el-tree
      :props="tree.props"
      :data="tree.provinces"
      :default-checked-keys="getDefaultCheckedKeys"
      ref="tree"
      node-key="code"
      accordion
      show-checkbox
      @node-expand="expandNode"
    ></el-tree>
  </div>
  <!-- :load="tree.load"
  lazy-->
  <!-- @check="onCheck"
  @check-change="onCheckChange"-->
</template>

<script>
export default {
  name: 'AreaTree',
  props: {
    checkedAddressList: {
      type: Array
    },
    // 要去过滤的区域code，key 为 addressType，value 为 code 集合
    disabledCodesObj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tree: {
        props: {
          label: 'name',
          // 禁用并不可展开
          disabled: (data, node) => {
            const disabledCodes = this.disabledCodesObj[data.addressType] || []
            if (disabledCodes.includes(data.code)) {
              node.isLeaf = true
              return true
            } else {
              return false
            }
          }
        },
        provinces: [],
        instance: null
      },
      cacheProvinceList: null // 缓存省数据
    }
  },
  computed: {
    getDefaultCheckedKeys() {
      return this.checkedAddressList
        .filter(({ hasNextIndex }) => !hasNextIndex)
        .map(({ code }) => code)
    }
  },
  created() {
    this.init()
  },
  methods: {
    /**
     * level: 1省 2市 3区 4镇乡街道
     */
    async getAddressList(level, parent = {}) {
      let api,
        params = { fatherCode: parent.code },
        resFields = {
          addressType: level,
          parentCode: parent.code,
          parentCodes: parent.code ? [...(parent.parentCodes || []), parent.code] : [],
          isExpand: false
        }
      if (level === 1) {
        api = 'user.getProvinces'
        params = {
          provinceCode: ''
        }
        resFields = {
          ...resFields,
          name: 'provinceName',
          code: 'provinceCode',
          children: [{ isFake: true }]
        }
      } else if (level === 2) {
        api = 'user.getCities'
        resFields = {
          ...resFields,
          name: 'cityName',
          code: 'cityCode',
          children: [{ isFake: true }]
        }
      } else if (level === 3) {
        api = 'user.getAreas'
        resFields = {
          ...resFields,
          name: 'areaName',
          code: 'areaCode',
          children: [{ isFake: true }]
        }
      } else if (level === 4) {
        api = 'user.getTowns'
        resFields = {
          ...resFields,
          name: 'townName',
          code: 'townCode'
        }
      } else {
        return []
      }
      const { success, data } = await this.$get(api, params)
      // console.log(api, params, success, data)

      if (success && data && data[0]) {
        const list = data[0].value
        if (list) {
          return list.map(address => {
            return {
              ...resFields,
              name: address[resFields.name],
              code: address[resFields.code]
            }
          })
        } else {
          return []
        }
      }
      return []
    },
    // 以 code 为 key，轻合并，不覆盖已有数据
    weakMergeList(baseList, toMergeList) {
      return [
        ...baseList,
        ...toMergeList.filter(tml => {
          return baseList.findIndex(bl => bl.code === tml.code) === -1
        })
      ]
    },
    // 展开省市区，懒加载 list
    async expandNode(data, node) {
      const { code, isExpand, addressType, parentCodes } = data
      if (isExpand) return // 已展开不查询数据
      const { checked } = node
      let toCheckCodes = []
      // 展开 province 时为 code，展开其他取 parentCodes[0]
      const province = this.tree.provinces.find(p => p.code === (parentCodes[0] || code))
      if (addressType === 1) {
        if (province) {
          const baseList = province.children.filter(c => !c.isFake)
          const toMergeList = await this.getAddressList(2, data)

          province.isExpand = true
          province.children = this.weakMergeList(baseList, toMergeList)
          // 父级被选中，懒加载时默认勾中
          if (checked) toCheckCodes = province.children.map(c => c.code)
        }
      } else {
        console.log(data, node, province)
        const cities = province.children
        // 展开 city 时为 code，展开其他取 parentCodes[1]
        const city = cities.find(c => c.code === (parentCodes[1] || code))

        if (addressType === 2) {
          if (city) {
            const baseList = city.children.filter(a => !a.isFake)
            const toMergeList = await this.getAddressList(3, data)

            city.isExpand = true
            city.children = this.weakMergeList(baseList, toMergeList)
            // 父级被选中，懒加载时默认勾中
            if (checked) toCheckCodes = city.children.map(a => a.code)
          }
        } else if (addressType === 3) {
          const areas = city.children
          // 展开 area 时为 code，展开其他取 parentCodes[2]
          const area = areas.find(a => a.code === (parentCodes[2] || code))
          if (area) {
            const baseList = area.children.filter(r => !r.isFake)
            const toMergeList = await this.getAddressList(4, data)

            area.isExpand = true
            area.children = this.weakMergeList(baseList, toMergeList)
            // 父级被选中，懒加载时默认勾中
            if (checked) toCheckCodes = area.children.map(r => r.code)
          }
        }
      }
      if (toCheckCodes.length > 0) {
        this.$nextTick(() => {
          const checkedKeys = this.getTreeInstance().getCheckedKeys()
          this.getTreeInstance().setCheckedKeys([...checkedKeys, ...toCheckCodes])
        })
      }
    },
    // 节点在展开时懒加载，所以需要渲染展开后节点的选中、半选状态
    getMockNodes(level, parent) {
      // 筛除出该级 全选、半选数据
      let addrList = this.checkedAddressList.filter(({ addressType }) => addressType === level)
      if ([2, 3, 4].includes(level)) {
        addrList = addrList.filter(({ parentCode }) => parentCode === parent.code)
      }
      addrList = addrList.map(({ hasNextIndex, name, code, addressType }) => {
        let addrObj = {
          hasNextIndex,
          name,
          code,
          addressType,
          isExpand: false,
          parentCode: null,
          parentCodes: []
        }
        if ([2, 3, 4].includes(level)) {
          addrObj.parentCode = parent.code
          addrObj.parentCodes = [...(parent.parentCodes || []), parent.code]
        }
        if (hasNextIndex) {
          // 仍有子级，递归设置该地区对象的子级
          return this.getMockNodes(level + 1, addrObj)
        } else {
          // 该地址对象为最后一级，渲染为选中
          if ([1, 2, 3].includes(level)) {
            // 这里的差异是省、市、区需展开且子级被全选才能渲染为被勾选，而街道只需被勾选
            addrObj.children = [{ name, code, isFake: true }]
          }
          return addrObj
        }
      })

      if (level === 1) {
        return addrList
      } else {
        // 既然进入市、区、街道的递归，说明父级为半选状态，故子级添加空对象，防止父级被全选
        addrList.push({ isFake: true })
        return {
          ...parent,
          children: addrList
        }
      }
      // if (level === 1) {
      //   const nodes = addrList.map(
      //     ({ hasNextIndex, name, code, addressType }) => {
      //       let res = {
      //         hasNextIndex,
      //         name,
      //         code,
      //         addressType,
      //         isExpand: false,
      //         parentCode: null,
      //         parentCodes: []
      //       }
      //       if (hasNextIndex) {
      //         // 仍有子级，说明未被全选，渲染半选
      //         return this.getMockNodes(level + 1, res)
      //       } else {
      //         // 省即为最后一级，渲染为全选
      //         res.children = [{ name, code, isFake: true }]
      //         return res
      //       }
      //     }
      //   )
      //   return nodes
      // } else {
      //   let children = addrList
      //     .filter(({ parentCode }) => parentCode === parent.code)
      //     .map(({ hasNextIndex, name, code, addressType }) => {
      //       let res = {
      //         hasNextIndex,
      //         name,
      //         code,
      //         addressType,
      //         isExpand: false,
      //         parentCode: parent.code,
      //         parentCodes: [...(parent.parentCodes || []), parent.code]
      //       }
      //       if (hasNextIndex) {
      //         // 仍有子级，说明未被全选，渲染半选
      //         return this.getMockNodes(level + 1, res)
      //       } else {
      //         // 为最后一级，渲染为全选
      //         res.children = [{ name, code, isFake: true }]
      //         console.log(res)
      //         return res
      //       }
      //     })
      //   // 留空帮助父对象渲染为半选, 标识 懒加载后删除
      //   children.push({ isFake: true })
      //   return {
      //     ...parent,
      //     children
      //   }
      // }
    },
    // onCheck(a, b, c) {
    //   console.log('onCheck', a, b, c)
    // },
    // onCheckChange(a, b, c) {
    //   console.log('onCheckChange', a, b, c)
    // },
    // getTree() {
    //   console.log(this.$refs['tree'].getCheckedNodes(false, true))
    // },
    // dialogChcek() {
    //   const $tree = this.$refs['tree']
    //   this.getKeysFromList(this.dialog.data)
    //   $tree.setCheckedKeys(defaultKeys)
    // },
    // getKeysFromList(list) {
    //   for (let i = 0; i < list.length; i++) {
    //     const l = list[i]
    //     if (l.hasNextIndex) {
    //       defaultKeys.push(l.addressCode)
    //     } else {
    //       this.getKeysFromList(l.nextAddressList)
    //     }
    //   }
    // },
    // async nodeExpand(data, b, c) {
    //   if (data) {
    //     1
    //   } else {
    //     const { level, code } = data
    //     // 市
    //     if (level === 1) {
    //       const index = this.tree.provinces.findIndex(d => d.code === data)
    //       this.tree.provinces[index].children = await this.getCities(code)
    //     }
    //   }
    //   console.log(data, b, c)
    // },
    getTreeInstance() {
      if (!this.tree.instance) {
        this.tree.instance = this.$refs['tree']
      }
      return this.tree.instance
    },
    // 获取有效的全选、半选数据
    getCheckedHalfCheckedData() {
      let checkedAddrs = this.getTreeInstance()
        .getCheckedNodes()
        .filter(({ isFake }) => !isFake) // 过滤只为了帮助父级渲染为全选、半选的假数据
      let halfCheckedAddrs = this.getTreeInstance().getHalfCheckedNodes()

      checkedAddrs = checkedAddrs
        .filter(addr => {
          // 和后端约定只保留被勾选的最大一级
          return !checkedAddrs.find(parentAddr => addr.parentCode === parentAddr.code)
        })
        .map(({ name, code, addressType, parentCode }) => {
          // 标识被勾选项
          return {
            name,
            code,
            addressType,
            parentCode,
            hasNextIndex: false
          }
        })
      halfCheckedAddrs = halfCheckedAddrs.map(({ name, code, addressType, parentCode }) => {
        // 标识半选状态的地址
        return {
          name,
          code,
          addressType,
          parentCode,
          hasNextIndex: true
        }
      })
      return [...checkedAddrs, ...halfCheckedAddrs]
    },
    async init() {
      if (!this.cacheProvinceList) {
        this.cacheProvinceList = await this.getAddressList(1)
      }
      this.tree.provinces = this.weakMergeList(this.getMockNodes(1), this.cacheProvinceList)
    }
  }
}
</script>

<style lang="less">
.area-tree {
  .el-tree .el-checkbox {
    min-width: 0 !important;
  }
}
</style>
<style lang="less" scoped>
.area-tree {
  max-height: 60vh;
  overflow: scroll;
}
</style>
